import { Button, Card, CardContent, List, Typography } from '@material-ui/core'
import { Alert, Skeleton } from '@material-ui/lab'
import React from 'react'

import { gregorianToJalaaliWithHourMinuteAndSecond } from '../../helpers/date'
import { addCommaToPrice } from '../../helpers/numbers'
import { getTranslate, lang } from '../../localization'
import { WalletTransaction } from '../../types/walletTransaction'
import FundingModeLabel from './FundingModeLabel'
import PaymentStatusBox from './PaymentStatusBox'
import StatusBox from './StatusBox'
import WalletTransactionSupportAction from './WalletTransactionSupportAction'
import useStyles from './styles/index.styles'

export default function WalletTransactionSupportMobile({
  data,
  loading,
  failed,
  available,
  onRetry
}: {
  data: (Pick<
    WalletTransaction,
    'transactionID' | 'type' | 'time' | 'amount' | 'currency'
  > &
    Partial<
      Pick<
        WalletTransaction,
        'fundingMode' | 'usedBalanceType' | 'status' | 'paymentStatus'
      >
    >)[]
  loading: boolean
  failed: boolean
  available: boolean
  onRetry: () => void
}) {
  const classes = useStyles()
  if (loading)
    return (
      <div role="status" aria-label={getTranslate('Loading transactions')}>
        <Skeleton variant="rect" height={96} />
      </div>
    )
  if (failed)
    return (
      <Alert
        severity="error"
        action={<Button onClick={onRetry}>{getTranslate('Retry')}</Button>}>
        {getTranslate('Unable to load transactions.')}
      </Alert>
    )
  if (!available) return null
  if (!data.length)
    return <Typography>{getTranslate('No transactions found.')}</Typography>
  return (
    <>
      {data.map((transaction) => (
        <Card
          key={transaction.transactionID}
          variant="outlined"
          className={classes.supportCard}>
          <CardContent>
            <Typography variant="subtitle2">
              {getTranslate(transaction.type)}
            </Typography>
            <Typography variant="body2">
              <bdi>
                {lang === 'fa'
                  ? gregorianToJalaaliWithHourMinuteAndSecond(transaction.time)
                  : transaction.time}
              </bdi>
            </Typography>
            <Typography variant="body2">
              {addCommaToPrice(transaction.amount)}{' '}
              {getTranslate(transaction.currency || '')}
            </Typography>
            <FundingModeLabel
              transaction={{
                fundingMode: transaction.fundingMode,
                usedBalanceType: transaction.usedBalanceType ?? null
              }}
            />
            {transaction.status && <StatusBox status={transaction.status} />}
            {transaction.paymentStatus && (
              <PaymentStatusBox status={transaction.paymentStatus} />
            )}
            <List disablePadding>
              <WalletTransactionSupportAction
                transactionID={transaction.transactionID}
                available={available}
              />
            </List>
          </CardContent>
        </Card>
      ))}
    </>
  )
}
